import { useAppDispatch } from '@/Application/Hooks/Redux';
import { setBuyNowPaymentError } from '@/modules/buy-now/infrastructure/slices/BuyNowSlice';
import { errorHandlerBuyNow } from '@/modules/buy-now/utils/error-handler/buy-now-error-handler';
import type { IErrorResponse } from '@/modules/buy-now/utils/error-handler/buy-now-error-handler.interfaces';

export const useBuyNowPaymentError = () => {
  const dispatch = useAppDispatch();

  const handleBuyNowPaymentError = (error?: IErrorResponse) => {
    const buyNowError = errorHandlerBuyNow(error);
    dispatch(setBuyNowPaymentError(buyNowError));
  };

  const clearBuyNowPaymentError = () => {
    dispatch(setBuyNowPaymentError(null));
  };

  return {
    handleBuyNowPaymentError,
    clearBuyNowPaymentError
  };
};
